import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import accountRestService from "../../services/acc-rest.service";
import letterMgmtRestService from "../../services/letter-mgmt-rest.service";
import {SearchCriteria} from "ps-letter-mgmtrest-client";


const initialState = {
    isUserLoading: false,
    loggedInUser: null,
    letters: [],
    lettersTotal: 0,
    lettersPage: 0,
    lettersTotalPages: 0,
    isLettersLoading: false,
    isSearchLettersToPresentToHudhurLoading: false,
    summaries: [],
    answers: [],
    lettersPresentToHudhur: [],
    assignedStacks: [],
    deliveredStacks: [],
    closedStacks: [],
    notAnsweredStacks: [],
    staffMembers: [],
    stackRequests: [],
    lettersByStack: null,
    currentStack: null,
    currentLetter: null,
    allStacks: [],
    myStacks: {
        FILTRATION: [],
        SUMMARY: [],
        ANSWER: []
        
    },
    userSettings: null,
    // PAP-343
    suspensionNotice: null,
    isSuspensionNoticeLoading: false,
    isSuspensionNoticeSaving: false
}

export const loadSuspensionNotice: any = createAsyncThunk(
    "app/loadSuspensionNotice",
    async ({callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.getSuspensionNotice();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateSuspensionNotice: any = createAsyncThunk(
    "app/updateSuspensionNotice",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateSuspensionNotice(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getLoggedInUser: any = createAsyncThunk(
    "app/getLoggedInUser",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await accountRestService.loadMe();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadLetters: any = createAsyncThunk(
    "app/loadLetters",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadLetters();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadLettersPaginated: any = createAsyncThunk(
    "app/loadLettersPaginated",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadLettersPaginated(finalData || {}, { signal: thunkAPI.signal });
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            if (error?.name === 'AbortError' || error?.name === 'CanceledError' || thunkAPI.signal.aborted) {
                return thunkAPI.rejectWithValue('Request cancelled');
            }
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadNewLetterCountsByLanguage: any = createAsyncThunk(
    "app/loadNewLetterCountsByLanguage",
    async ({callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadNewLetterCountsByLanguage();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadMyModifiedLetters: any = createAsyncThunk(
    "app/loadMyModifiedLetters",
    async ({callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadMyModifiedLetters();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const loadStaffMembers: any = createAsyncThunk(
    "app/loadStaffMembers",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadStaffMembers();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const addInstructions = createAsyncThunk(
    "app/addInstructions",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.addInstructions(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadLetter: any = createAsyncThunk(
    "app/loadLetter",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadLetter(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateLetter: any = createAsyncThunk(
    "app/updateLetter",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateLetter(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadMyStacks: any = createAsyncThunk(
    "app/loadMyStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadMyStacks();
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return {
                FILTRATION: response.filter(stackDto => stackDto.assignedStackType === "FILTRATION" || (stackDto.assignedStackType === null && stackDto.requestedStackType === "FILTRATION")),
                SUMMARY: response.filter(stackDto => stackDto.assignedStackType === "SUMMARY" || (stackDto.assignedStackType === null && stackDto.requestedStackType === "SUMMARY")),
                ANSWER: response.filter(stackDto => stackDto.assignedStackType === "ANSWER" || (stackDto.assignedStackType === null && stackDto.requestedStackType === "ANSWER"))

            };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createStackRequest: any = createAsyncThunk(
    "app/createStackRequest",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.createStackRequest(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createSummary: any = createAsyncThunk(
    "app/createSummary",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.createSummary(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateSummary: any = createAsyncThunk(
    "app/updateSummary",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateSummary(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadSummaries: any = createAsyncThunk(
    "app/loadSummaries",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadSummaries(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createAnswer: any = createAsyncThunk(
    "app/createAnswer",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.createAnswer(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateAnswer: any = createAsyncThunk(
    "app/updateAnswer",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateAnswer(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteSummary: any = createAsyncThunk(
    "app/deleteSummary",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.deleteSummary(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return finalData;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteAnswer: any = createAsyncThunk(
    "app/deleteAnswer",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.deleteAnswer(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return finalData;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const adoptSummary: any = createAsyncThunk(
    "app/adoptSummary",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.adoptSummary(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const adoptAnswer: any = createAsyncThunk(
    "app/adoptAnswer",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.adoptAnswer(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unadoptSummary: any = createAsyncThunk(
    "app/unadoptSummary",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.unadoptSummary(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unadoptAnswer: any = createAsyncThunk(
    "app/unadoptAnswer",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.unadoptAnswer(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadAnswers: any = createAsyncThunk(
    "app/loadAnswers",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadAnswers(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const assignStackRequest: any = createAsyncThunk(
    "app/assignStackRequest",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.assignStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const reassignStack: any = createAsyncThunk(
    "app/reassignStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.reassignStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const extendStack: any = createAsyncThunk(
    "app/extendStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.extendStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const joinStacks: any = createAsyncThunk(
    "app/joinStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.joinStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unassignStack: any = createAsyncThunk(
    "app/unassignStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.unassignStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deliverStack: any = createAsyncThunk(
    "app/deliverStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.deliverStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const downloadStackAttachment: any = createAsyncThunk(
    "app/downloadStackAttachment",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadStackAttachment(finalData);
            
                if (response.status === 200) {
                    const contentDisposition = response.headers["content-disposition"]
                    const filename = contentDisposition ? contentDisposition.split("=")[1] : "Stack-"+finalData.stackId+"-attachments.zip";
                    const FileDownload = require('js-file-download');
                    FileDownload(response.data, filename);
                    if (typeof callbackSuccess === 'function')
                        callbackSuccess(response)
                } else {
                    if (typeof callbackSuccess === 'function')
                        callbackError(JSON.stringify(response))
                }
                return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const downloadAttachment: any = createAsyncThunk(
    "app/downloadAttachment",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadAttachment(finalData);

            if (response.status === 200) {
                const contentDisposition = response.headers["content-disposition"]
                const filename = contentDisposition ? contentDisposition.split("=")[1] : "Letter-"+finalData.id+"-attachment.docx";
                const FileDownload = require('js-file-download');
                FileDownload(response.data, filename);
                if (typeof callbackSuccess === 'function')
                    callbackSuccess(response)
            } else {
                if (typeof callbackSuccess === 'function')
                    callbackError(JSON.stringify(response))
            }
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadAttachmentBlob: any = createAsyncThunk(
    "app/loadAttachmentBlob",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadAttachment(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const downloadMultipleLetters: any = createAsyncThunk(
    "app/downloadMultipleLetters",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadMultipleLetters(finalData);

            if (response.status === 200) {
                const contentDisposition = response.headers["content-disposition"]
                const filename = contentDisposition ? contentDisposition.split("=")[1] : "Multiple-Letters.zip";
                const FileDownload = require('js-file-download');
                FileDownload(response.data, filename);
                if (typeof callbackSuccess === 'function')
                    callbackSuccess(response)
            } else {
                if (typeof callbackSuccess === 'function')
                    callbackError(JSON.stringify(response))
            }
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const downloadLettersForHudhur: any = createAsyncThunk(
    "app/downloadLettersForHudhur",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadForLetterForHudhur(finalData);

            if (response.status === 200) {
                const contentDisposition = response.headers["content-disposition"]
                const filename = contentDisposition ? contentDisposition.split("=")[1] : "Letters-to-Huzoor.docx";
                const FileDownload = require('js-file-download');
                FileDownload(response.data, filename);
                if (typeof callbackSuccess === 'function')
                    callbackSuccess(response)
            } else {
                if (typeof callbackSuccess === 'function')
                    callbackError(JSON.stringify(response))
            }
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const submitStack: any = createAsyncThunk(
    "app/submitStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.submitStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const closeStack: any = createAsyncThunk(
    "app/closeStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.closeStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const closeAndCreateReviewStack: any = createAsyncThunk(
    "app/closeAndCreateReviewStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.closeAndCreateReviewStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const reopenStack: any = createAsyncThunk(
    "app/reopenStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.reopenStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const rollbackReviewStack: any = createAsyncThunk(
    "app/rollbackReviewStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.rollbackReviewStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const searchLettersToPresentToHudhur: any = createAsyncThunk(
    "app/searchLettersToPresentToHudhur",
    async ({search, language, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const searchCriteriaList: SearchCriteria[] = [
                {
                    filterKey: "internalStatus",
                    value: "LETTER_PRESENTED_TO_HUDHUR",
                    operation: "eq",
                    dataOption: "ALL"
                }
            ];

            if (language && language.length > 0) {
                language.forEach((lang: string) => {
                    searchCriteriaList.push({
                        filterKey: "originalLetter.language",
                        value: lang,
                        operation: "eq",
                        dataOption: "ANY"
                    });
                });
            }

            if (search && search.trim().length > 0) {
                searchCriteriaList.push({
                    filterKey: "originalLetter.sender.firstName",
                    value: search.trim(),
                    operation: "cn",
                    dataOption: "ANY"
                });
                searchCriteriaList.push({
                    filterKey: "originalLetter.sender.lastName",
                    value: search.trim(),
                    operation: "cn",
                    dataOption: "ANY"
                });
            }

            const finalData: any = {
                search: {
                    searchCriteriaList,
                    dataOption: "ALL"
                }
            };
            const response = await letterMgmtRestService.searchLetters(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadLettersByStack: any = createAsyncThunk(
    "app/loadLettersByStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadLettersByStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadStack: any = createAsyncThunk(
    "app/loadStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.getStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadAssignedStacks: any = createAsyncThunk(
    "app/loadAssignedStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadAssignedStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadDeliveredStacks: any = createAsyncThunk(
    "app/loadDeliveredStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadDeliveredStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadClosedStacks: any = createAsyncThunk(
    "app/loadClosedStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadClosedStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadAllStacks: any = createAsyncThunk(
    "app/loadAllStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadAllStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadAllNotAnsweredStacks: any = createAsyncThunk(
    "app/loadAllNotAnsweredStacks",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadAllNotAnsweredStacks(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteStack: any = createAsyncThunk(
    "app/deleteStack",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.deleteStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const loadStackRequests: any = createAsyncThunk(
    "app/loadStackRequests",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.loadRequestedStacks(finalData);
            console.log(finalData, response, callbackSuccess, callbackError)
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateLetterMetadata: any = createAsyncThunk(
    "app/updateLetterMetadata",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateLetterMetadata(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const cancelLetter = createAsyncThunk(
    "app/cancelLetter",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.cancelLetter(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const presentToHudhur = createAsyncThunk(
    "app/presentToHudhur",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.presentToHudhur(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const downloadLetter: any = createAsyncThunk(
    "app/downloadLetter",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.downloadLetter(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getUserSettings: any = createAsyncThunk(
    "app/getUserSettings",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.getUserSettings(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const saveUserSettings: any = createAsyncThunk(
    "app/saveUserSettings",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.saveUserSettings(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateStackSummaryOrder: any = createAsyncThunk(
    "app/updateStackSummaryOrder",
    async ({finalData, callbackSuccess, callbackError}: any, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.updateStackSummaryOrder(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response)
            return response;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// ==================== Review Feature Actions ====================

export const reviewLetter: any = createAsyncThunk(
    "app/reviewLetter",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.reviewLetter(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const uploadCustomPdf: any = createAsyncThunk(
    "app/uploadCustomPdf",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.uploadCustomPdf(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const resetToOriginalAnswerPdf: any = createAsyncThunk(
    "app/resetToOriginalAnswerPdf",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.resetToOriginalAnswerPdf(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const retryDelivery: any = createAsyncThunk(
    "app/retryDelivery",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.retryDelivery(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const submitReviewStack: any = createAsyncThunk(
    "app/submitReviewStack",
    async ({finalData, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.submitReviewStack(finalData);
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Digital-answer telemetry for one letter (download count, async-job success/failure).
// Returns the AnswerEvent list from Postbox (proxied via office-api). The caller renders
// it via callbackSuccess (consistent with the other action thunks here).
export const getLetterDownloadHistory: any = createAsyncThunk(
    "app/getLetterDownloadHistory",
    async ({letterId, callbackSuccess, callbackError}, thunkAPI) => {
        try {
            const response = await letterMgmtRestService.getLetterDownloadHistory({letterId});
            if (typeof callbackSuccess === 'function')
                callbackSuccess(response);
            return response;
        } catch (error) {
            const message = error.message || error.toString();
            if (typeof callbackError === 'function')
                callbackError(message)
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setAppState: (state, action) => {
            console.log("Action called setAppState")
            console.log(state)
            console.log(action.payload)
            state = {...state, ...action.payload};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLoggedInUser.pending, (state) => {
                state.isLoggeInUserLoading = true;
            })
            .addCase(getLoggedInUser.fulfilled, (state, action) => {
                state.isLoggeInUserLoading = false;
                state.loggedInUser = action.payload;
            })
            .addCase(getLoggedInUser.rejected, (state, action) => {
                state.isLoggeInUserLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadLetters.pending, (state) => {
                state.isLettersLoading = true;
            })
            .addCase(loadLetters.fulfilled, (state, action) => {
                state.isLettersLoading = false;
                state.letters = action.payload;
            })
            .addCase(loadLettersPaginated.pending, (state) => {
                state.isLettersLoading = true;
            })
            .addCase(loadLettersPaginated.fulfilled, (state, action) => {
                state.isLettersLoading = false;
                // Handle paginated response
                if (action.payload && action.payload.content) {
                    state.letters = action.payload.content;
                    state.lettersTotal = action.payload.totalElements;
                    state.lettersPage = action.payload.number;
                    state.lettersTotalPages = action.payload.totalPages;
                } else {
                    // Fallback for non-paginated response
                    state.letters = action.payload;
                }
            })
            .addCase(loadLettersPaginated.rejected, (state, action) => {
                // Don't update state for aborted/cancelled requests
                if (action.meta?.aborted) return;
                state.isLettersLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadMyModifiedLetters.pending, (state) => {
                state.isLettersLoading = true;
            })
            .addCase(loadMyModifiedLetters.fulfilled, (state, action) => {
                state.isLettersLoading = false;
                state.letters = action.payload;
                state.lettersTotal = action.payload?.length || 0;
            })
            .addCase(loadMyModifiedLetters.rejected, (state, action) => {
                state.isLettersLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadLetters.rejected, (state, action) => {
                state.isLettersLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(searchLettersToPresentToHudhur.pending, (state) => {
                state.isSearchLettersToPresentToHudhurLoading = true;
            })
            .addCase(searchLettersToPresentToHudhur.fulfilled, (state, action) => {
                state.isSearchLettersToPresentToHudhurLoading = false;
                state.lettersPresentToHudhur = action.payload;
            })
            .addCase(searchLettersToPresentToHudhur.rejected, (state, action) => {
                state.isSearchLettersToPresentToHudhurLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadLetter.pending, (state) => {
                state.isLetterLoading = true;
            })
            .addCase(loadLetter.fulfilled, (state, action) => {
                state.isLetterLoading = false;
                state.currentLetter = action.payload;
                state.lettersByStack = state.lettersByStack != null ? state.lettersByStack.map(letter => letter.id === action.payload.id ? action.payload : letter) : null;
            })
            .addCase(loadLetter.rejected, (state, action) => {
                state.isLetterLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(updateLetter.pending, (state) => {
                state.isLetterLoading = true;
            })
            .addCase(updateLetter.fulfilled, (state, action) => {
                state.isLetterLoading = false;
                state.currentLetter = action.payload;
                state.lettersByStack = state.lettersByStack != null ? state.lettersByStack.map(letter => letter.id === action.payload.id ? action.payload : letter) : null;
                
            })
            .addCase(updateLetter.rejected, (state, action) => {
                state.isLetterLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadLettersByStack.pending, (state) => {
                state.isLettersByStackLoading = true;
            })
            .addCase(loadLettersByStack.fulfilled, (state, action) => {
                state.isLettersByStackLoading = false;
                state.lettersByStack = action.payload;
            })
            .addCase(loadLettersByStack.rejected, (state, action) => {
                state.isLettersByStackLoading = false;
                state.lettersByStack = [];
                state.errorPaylod = action.payload;
            })
            .addCase(loadStack.pending, (state) => {
                state.isCurrentStackLoading = true;
            })
            .addCase(loadStack.fulfilled, (state, action) => {
                state.isCurrentStackLoading = false;
                state.currentStack = action.payload;
            })
            .addCase(loadStack.rejected, (state, action) => {
                state.isCurrentStackLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(createStackRequest.pending, (state) => {
                state.isCreateStackRequestLoading = true;
            })
            .addCase(createStackRequest.fulfilled, (state, action) => {
                state.isCreateStackRequestLoading = false;
                state.myStacks[action.payload.requestedStackType].push(action.payload) 
            })
            .addCase(createStackRequest.rejected, (state, action) => {
                state.isCreateStackRequestLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(createSummary.pending, (state) => {
                state.isCreateSummaryLoading = true;
            })
            .addCase(createSummary.fulfilled, (state, action) => {
                state.isCreateSummaryLoading = false;
                state.summaries.push(action.payload)
            })
            .addCase(createSummary.rejected, (state, action) => {
                state.isCreateSummaryLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(updateSummary.pending, (state) => {
                state.isCreateSummaryLoading = true;
            })
            .addCase(updateSummary.fulfilled, (state, action) => {
                state.isCreateSummaryLoading = false;
                state.summaries = state.summaries.map(summary => {
                                                return summary.id === action.payload.id ? action.payload : summary;
                                    });
            })
            .addCase(updateSummary.rejected, (state, action) => {
                state.isCreateSummaryLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadSummaries.pending, (state) => {
                state.isSummariesLoading = true;
            })
            .addCase(loadSummaries.fulfilled, (state, action) => {
                state.isSummariesLoading = false;
                state.summaries = action.payload;
            })
            .addCase(loadSummaries.rejected, (state, action) => {
                state.isSummariesLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(createAnswer.pending, (state) => {
                state.isCreateAnswerLoading = true;
            })
            .addCase(createAnswer.fulfilled, (state, action) => {
                state.isCreateAnswerLoading = false;
                state.answers.push(action.payload)
            })
            .addCase(createAnswer.rejected, (state, action) => {
                state.isCreateAnswerLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(updateAnswer.pending, (state) => {
                state.isCreateAnswerLoading = true;
            })
            .addCase(updateAnswer.fulfilled, (state, action) => {
                state.isCreateAnswerLoading = false;
                state.answers = state.answers.map(answer => {
                    return answer.id === action.payload.id ? action.payload : answer;
                });
            })
            .addCase(updateAnswer.rejected, (state, action) => {
                state.isCreateAnswerLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(deleteSummary.fulfilled, (state, action) => {
                state.summaries = state.summaries.filter(s => s.id !== action.payload.id);
            })
            .addCase(deleteAnswer.fulfilled, (state, action) => {
                state.answers = state.answers.filter(a => a.id !== action.payload.id);
            })
            .addCase(adoptSummary.fulfilled, (state, action) => {
                state.summaries = state.summaries.map(s => s.id === action.payload.id ? action.payload : s);
            })
            .addCase(adoptAnswer.fulfilled, (state, action) => {
                state.answers = state.answers.map(a => a.id === action.payload.id ? action.payload : a);
            })
            .addCase(unadoptSummary.fulfilled, (state, action) => {
                state.summaries = state.summaries.map(s => s.id === action.payload.id ? action.payload : s);
            })
            .addCase(unadoptAnswer.fulfilled, (state, action) => {
                state.answers = state.answers.map(a => a.id === action.payload.id ? action.payload : a);
            })
            .addCase(loadAnswers.pending, (state) => {
                state.isAnswersLoading = true;
            })
            .addCase(loadAnswers.fulfilled, (state, action) => {
                state.isAnswersLoading = false;
                state.answers = action.payload;
            })
            .addCase(loadAnswers.rejected, (state, action) => {
                state.isAnswersLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadMyStacks.pending, (state) => {
                state.isMyStackRequestLoading = true;
            })
            .addCase(loadMyStacks.fulfilled, (state, action) => {
                state.isMyStackRequestLoading = false;
                state.myStacks = action.payload
            })
            .addCase(loadMyStacks.rejected, (state, action) => {
                state.isMyStackRequestLoading = false;
                state.errorPaylod = action.payload;
            })
            .addCase(loadAssignedStacks.pending, (state) => {
                state.isStacksLoading = true;
            })
            .addCase(loadAssignedStacks.fulfilled, (state, action) => {
                state.isStacksLoading = false;
                state.assignedStacks = action.payload;
            })
            .addCase(loadAssignedStacks.rejected, (state, action) => {
                state.isStacksLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadDeliveredStacks.pending, (state) => {
                state.isStacksLoading = true;
            })
            .addCase(loadDeliveredStacks.fulfilled, (state, action) => {
                state.isStacksLoading = false;
                state.deliveredStacks = action.payload;
            })
            .addCase(loadDeliveredStacks.rejected, (state, action) => {
                state.isStacksLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadClosedStacks.pending, (state) => {
                state.isStacksLoading = true;
            })
            .addCase(loadClosedStacks.fulfilled, (state, action) => {
                state.isStacksLoading = false;
                state.closedStacks = action.payload;
            })
            .addCase(loadClosedStacks.rejected, (state, action) => {
                state.isStacksLoading = false;
                state.errorPayload = action.payload;
            })            
            .addCase(loadAllStacks.pending, (state) => {
                state.isStacksLoading = true;
            })
            .addCase(loadAllStacks.fulfilled, (state, action) => {
                state.isStacksLoading = false;
                state.allStacks = action.payload;
            })
            .addCase(loadAllStacks.rejected, (state, action) => {
                state.isStacksLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadStackRequests.pending, (state) => {
                state.isStackRequestsLoading = true;
            })
            .addCase(loadAllNotAnsweredStacks.fulfilled, (state, action) => {
                state.isStacksLoading = false;
                state.notAnsweredStacks = action.payload;
            })
            .addCase(loadAllNotAnsweredStacks.rejected, (state, action) => {
                state.isStacksLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadAllNotAnsweredStacks.pending, (state) => {
                state.isStackRequestsLoading = true;
            })
            .addCase(loadStackRequests.fulfilled, (state, action) => {
                state.isStackRequestsLoading = false;
                state.stackRequests = action.payload;
            })
            .addCase(loadStackRequests.rejected, (state, action) => {
                state.isStackRequestsLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadStaffMembers.pending, (state) => {
                state.isStaffMembersLoading = true;
            })
            .addCase(loadStaffMembers.fulfilled, (state, action) => {
                state.isStaffMembersLoading = false;
                state.staffMembers = action.payload;
            })
            .addCase(loadStaffMembers.rejected, (state, action) => {
                state.isStaffMembersLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(reassignStack.pending, (state) => {
                state.isReassignStackLoading = true;
            })
            .addCase(reassignStack.fulfilled, (state, action) => {
                state.isReassignStackLoading = false;
            })
            .addCase(reassignStack.rejected, (state, action) => {
                state.isReassignStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(extendStack.pending, (state) => {
                state.isExtendStackLoading = true;
            })
            .addCase(extendStack.fulfilled, (state, action) => {
                state.isExtendStackLoading = false;
            })
            .addCase(extendStack.rejected, (state, action) => {
                state.isExtendStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(joinStacks.pending, (state) => {
                state.isJoinStacksLoading = true;
            })
            .addCase(joinStacks.fulfilled, (state, action) => {
                state.isJoinStacksLoading = false;
            })
            .addCase(joinStacks.rejected, (state, action) => {
                state.isJoinStacksLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(unassignStack.pending, (state) => {
                state.isUnassignStackLoading = true;
            })
            .addCase(unassignStack.fulfilled, (state, action) => {
                state.isUnassignStackLoading = false;
            })
            .addCase(unassignStack.rejected, (state, action) => {
                state.isUnassignStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(deliverStack.pending, (state) => {
                state.isDeliverStackLoading = true;
            })
            .addCase(deliverStack.fulfilled, (state, action) => {
                state.isDeliverStackLoading = false;
            })
            .addCase(deliverStack.rejected, (state, action) => {
                state.isDeliverStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(closeStack.pending, (state) => {
                state.isCloseStackLoading = true;
            })
            .addCase(closeStack.fulfilled, (state, action) => {
                state.isCloseStackLoading = false;
            })
            .addCase(closeStack.rejected, (state, action) => {
                state.isCloseStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(submitStack.pending, (state) => {
                state.isSubmitStackLoading = true;
            })
            .addCase(submitStack.fulfilled, (state, action) => {
                state.isSubmitStackLoading = false;
            })
            .addCase(submitStack.rejected, (state, action) => {
                state.isSubmitStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(deleteStack.pending, (state) => {
                state.isDeleteStackLoading = true;
            })
            .addCase(deleteStack.fulfilled, (state, action) => {
                state.isDeleteStackLoading = false;
            })
            .addCase(deleteStack.rejected, (state, action) => {
                state.isDeleteStackLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(getUserSettings.pending, (state) => {
                state.isUserSettingsLoading = true;
            })
            .addCase(getUserSettings.fulfilled, (state, action) => {
                state.isUserSettingsLoading = false;
                state.userSettings = action.payload;
            })
            .addCase(getUserSettings.rejected, (state, action) => {
                state.isUserSettingsLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(saveUserSettings.pending, (state) => {
                state.isSaveUserSettingsLoading = true;
            })
            .addCase(saveUserSettings.fulfilled, (state, action) => {
                state.isSaveUserSettingsLoading = false;
                state.userSettings = action.payload;
            })
            .addCase(saveUserSettings.rejected, (state, action) => {
                state.isSaveUserSettingsLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(loadSuspensionNotice.pending, (state) => {
                state.isSuspensionNoticeLoading = true;
            })
            .addCase(loadSuspensionNotice.fulfilled, (state, action) => {
                state.isSuspensionNoticeLoading = false;
                state.suspensionNotice = action.payload;
            })
            .addCase(loadSuspensionNotice.rejected, (state, action) => {
                state.isSuspensionNoticeLoading = false;
                state.errorPayload = action.payload;
            })
            .addCase(updateSuspensionNotice.pending, (state) => {
                state.isSuspensionNoticeSaving = true;
            })
            .addCase(updateSuspensionNotice.fulfilled, (state, action) => {
                state.isSuspensionNoticeSaving = false;
                state.suspensionNotice = action.payload;
            })
            .addCase(updateSuspensionNotice.rejected, (state, action) => {
                state.isSuspensionNoticeSaving = false;
                state.errorPayload = action.payload;
            })
            .addCase(updateStackSummaryOrder.pending, (state) => {
                state.isUpdateStackSummaryOrderLoading = true;
            })
            .addCase(updateStackSummaryOrder.fulfilled, (state, action) => {
                state.isUpdateStackSummaryOrderLoading = false;
                // Update the current stack with the new summary order
                if (state.currentStack && state.currentStack.id === action.payload.id) {
                    state.currentStack = action.payload;
                }
            })
            .addCase(updateStackSummaryOrder.rejected, (state, action) => {
                state.isUpdateStackSummaryOrderLoading = false;
                state.errorPayload = action.payload;
            })
    },
});

export const {setAppState} = appSlice.actions;

export default appSlice.reducer;